<template>
<div class="page-wrapper">
  <div class="content" v-if="certificateInfo">
  <div class="pt16 pb16">
    <table-list
      :title="'应收账单信息'"
      :columns="columns"
      :data="tableData"
      :loading="false"
      :show-page="false"
    >
    </table-list>
  </div>
  <div class="mt36">
    <h3 class="title">收款</h3>
    <Row :gutter="16" class="mb16">
      <Col span="6">待收金额：<span class="info">{{unReceivedBillAmount2}}</span></Col>
      <Col span="6">本次录入金额：<span class="info">{{inputNUmber}}</span></Col>
    </Row>
    <div >
      <collection-item ref="collection" :billNum="billNum" :formData="formData" :projectFid="projectFid" :receiptMethodList="receiptMethodList" @inputPayment = "inputPayment"  @show-img="showImg"></collection-item>
    </div>
  </div>
  <div  class="btn-wrap">
    <Button type="primary" size="large" @click="save1227" :loading="btnLoading">
      <span>提交</span>
    </Button>
  </div>
  </div>
</div>

</template>

<script type="text/ecmascript-6">
import {certificateDetail,getReceiptMethod,updatePaymentVoucher} from 'api/accountsReceivable';
import TableList from 'components/TableList/index';
import CollectionItem from './components/CollectionItem';
export default {
  created(){
    this.projectFid = this.$route.query.proId
    this.billNum = this.$route.query.bNum
    this.contractCode = this.$route.query.cCode
    this.getDetail()
  },
  activated(){
    if(this.isActive){
      this.projectFid = this.$route.query.proId
      this.billNum = this.$route.query.bNum
      this.contractCode = this.$route.query.cCode
      this.getDetail()
    } else {
      this.isActive = true
    }

  },
  computed:{
    tag() {
      return this.$store.state.tagsView.visitedViews.find(tag => {
        return tag.path===this.$route.path
      });
    },
    clickedCardsList(){
      let arr = []
      this.cardsList.forEach( item => {
        if(item.status === 1){
          arr.push({
            code:item.code,
            money:(item.money/100).toFixed(2),
            type:item.type
          })
        }
      })
      return arr
    },
    cardsTotal(){
      return this.clickedCardsList.reduce((sum,cur) => {
        return sum + +cur.money
      },0)
    },
  },
  data () {
    const validatePrice = (rule, value, callback)=>{
      const pattern = /^(([1-9]{1}\d*)|(0{1}))(\.\d{0,2})?$/
      if(pattern.test(value)){
        this.$emit('inputPayment')
        callback();
      }else {
        callback(new Error('输入正确的数字'));
      }
    }
    const validateReferenceNum = (rule, value ,callback) => {
      let count = this.referenceNumLen
      let patternStr = `^[A-Za-z0-9]{${count}}$`
      const pattern = new RegExp(patternStr)
      if(!count || pattern.test(value)){
        callback();
      }else {
        callback(new Error('输入正确位数的参考号'));
      }
    }
    const paySerialNum = (rule, value ,callback) => {
      let str = this.paySerialLabel
      if(value){
        callback()
      }else{
        callback(new Error(str))
      }
    }
    return {
      imgSrc:'',
      contractCode:'',
      projectFid:'',
      billNum:'',
      receiptMethodList:[],
      tableData: [],
      columns: [
        {
          title: '应收账单编号',
          key: 'billNum',
          align: 'center'
        },
        {
          title: '合同号',
          key: 'outContractCode',
          align: 'center'
        },
        {
          title: '房间/床位',
          key: 'stockNumber',
          align: 'center'
        },
        {
          title: '费用项',
          key: 'costCodeName',
          align: 'center'

        },
        {
          title: '账单金额',
          key: 'receiptBillAmount',
          align: 'center',
          render: (h, params) => {
            return h('span', (params.row.receiptBillAmount / 100).toFixed(2))
          }
        },
        {
          title: '实收金额',
          key: 'receivedBillAmount',
          align: 'center',
          render: (h, params) => {
            return h('span', (params.row.receivedBillAmount / 100).toFixed(2))
          }
        },
        {
          title: '待收金额',
          key: '',
          align: 'center',
          render: (h, params) => {
            return h('span', ((params.row.receiptBillAmount-params.row.receivedBillAmount) / 100).toFixed(2))
          }
        },
      ],
      projectFid: '',
      billNum: '',
      certificateInfo: null,
      payType: '',
      unReceivedBillAmount2:0,
      inputNUmber:0,
      btnLoading:false,
      isActive:false,
      formData:{
        attach:'',
        checkNumber:'', //支票号
        factPayment:'',
        paySerialNum:'',
        payTime:'',
        payType:'',
        payer:'',
        posId:'',
        referenceNum:'',
        remark:'',
        remittanceAccount:'',
      }
    };
  },
  components:{
    CollectionItem,
    TableList
  },
  methods:{
    showImg(img){
      this.imgSrc =img
      this.showImgKey++
    },
    save1227(){
      if(this.unReceivedBillAmount2 < this.inputNUmber ){
        this.$Modal.confirm({
          title: '消息提醒',
          content: '实收金额大于应收金额，将生成多收款！',
          onOk: () => {
            this.save()
          }
        })
        return
      }
      this.save()
    },
    save(){
      let data = {
        billNum:this.billNum,
        contractId:this.contractCode,
      }
      let receipts = this.validateCollections()
      if(receipts){
        this.btnLoading=true
        data = Object.assign({},data,receipts)
        updatePaymentVoucher(data).then( res=>{
           this.$Message.success('提交成功!');
           this.closeTag()
           this.btnLoading=false
        }).catch(res => {
          this.btnLoading=false
        })
      }
    },
    validateCollections(){
      return  this.$refs.collection.formValidate()
    },
    getDetail() {
      getReceiptMethod(this.contractCode).then( res => {
        this.receiptMethodList = res.data
      })
      certificateDetail(this.projectFid, this.billNum).then(res => {
        this.certificateInfo = res.data
        this.payType = res.data.paymentTypeCode
        this.tableData = res.data.receiptList
        if(this.tableData) {
          this.unReceivedBillAmount2 = ((Number(this.tableData[0].receiptBillAmount)-Number(this.tableData[0].receivedBillAmount)) / 100).toFixed(2)
        }
        if(this.certificateInfo) {
          this.inputNUmber = (Number(this.certificateInfo.totalAmount)/100).toFixed(2)
        }
        if(this.certificateInfo.annexList) {
          this.formData.attach = this.certificateInfo.annexList[0]
        }
        this.formData.checkNumber = this.certificateInfo.checkNumber
        this.formData.factPayment = (Number(this.certificateInfo.totalAmount)/100).toFixed(2)
        this.formData.paySerialNum = this.certificateInfo.paySerialNum
        this.formData.payTime = this.certificateInfo.payTime
        this.formData.payType = this.certificateInfo.paymentTypeCode
        this.formData.payer = this.certificateInfo.payer
        this.formData.posId = this.certificateInfo.terminalNo
        this.formData.referenceNum = this.certificateInfo.referenceNum
        this.formData.remark = this.certificateInfo.remark
        this.formData.remittanceAccount =this.certificateInfo.bankAccount
      })
    },
    getTotal(){
      let factPayment = +this.$refs.collection.formData.factPayment
      return  factPayment
    },
    inputPayment(){
      let total = this.getTotal()
      this.inputNUmber=total
    },
    closeTag(){
      // this.$router.push({ name: 'paymentvoucher'})
      this.$routerGo({ name: 'paymentvoucher'})
    },
  }
}
</script>

<style lang="css" scoped>
 .table-wrap {
  position: relative;
  border: 1px solid #dddee1;
    border-bottom: 0;
    border-right: 0;
}
table {
  width: 100%;
}
th,td {
  text-align: center;
}
.btn-wrap {
width: 100%;
text-align: center;
}
.cards {
  display: inline-block;
  width:80px;
  height: 32px;
  line-height: 32px;
  border: 1px solid #DDDEE1;
  border-radius: 2px;
  text-align: center;
  margin-left: 16px;
}
.cards.checked {
 border: 1px solid #CFA868;
}
.flex {
  display: flex;
}
.flex .label {
  flex: 0 0 60px;
}
.info {
  padding-left: 8px;
  font-weight: 600;
}
.ivu-col {
  line-height: 2.5;
}
</style>
